(function () {
  'use strict';
  const root = document.querySelector('[data-jmf-fulfilment]');
  if (!root) return;

  const dateInput = root.querySelector('#jmf-requested-date');
  const dateTrigger = root.querySelector('[data-jmf-date-trigger]');
  const dateText = root.querySelector('[data-jmf-date-text]');
  const calendar = root.querySelector('[data-jmf-calendar]');
  const monthTitle = root.querySelector('[data-jmf-calendar-month]');
  const days = root.querySelector('[data-jmf-calendar-days]');
  const previous = root.querySelector('[data-jmf-calendar-prev]');
  const next = root.querySelector('[data-jmf-calendar-next]');
  const help = root.querySelector('[data-jmf-calendar-help]');
  const hint = root.querySelector('[data-jmf-hint]');
  const error = root.querySelector('[data-jmf-error]');
  const options = [...root.querySelectorAll('[name="jmf_fulfilment_method"]')];
  const attributeMethod = 'Preferred fulfilment method';
  const attributeDate = 'Requested fulfilment date';
  const notePrefix = 'JMF requested fulfilment: ';
  const bankHolidays = new Set([
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25',
    '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31',
    '2027-08-30', '2027-12-27', '2027-12-28',
    '2028-01-03', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-29',
    '2028-08-28', '2028-12-25', '2028-12-26'
  ]);
  let lastPublishedDate = '2028-12-31';
  fetch('https://www.gov.uk/bank-holidays.json', { credentials: 'omit' })
    .then(response => { if (!response.ok) throw new Error('Holiday feed unavailable'); return response.json(); })
    .then(data => {
      const events = data['england-and-wales']?.events;
      if (!Array.isArray(events) || !events.length) return;
      bankHolidays.clear();
      events.forEach(event => bankHolidays.add(event.date));
      const lastYear = Math.max(...events.map(event => Number(event.date.slice(0, 4))));
      lastPublishedDate = `${lastYear}-12-31`;
      if (calendar.open) renderCalendar();
    })
    .catch(() => {});
  let pending = Promise.resolve();
  let touched = false;
  let shownMonth;
  let resumeCheckout = false;
  let sampleOnly = false;
  let customRailOrder = false;
  let glazedOrder = false;
  const sampleProductId = 15993967772029;
  const legacySampleFeeVariantId = 58544588128637;

  function hasCustomRailWidth(item) {
    if (Number(item.product_id) === sampleProductId) return false;
    const properties = item.properties || {};
    if (properties._railSurchargeVariant || properties._midrailSurchargeVariant) return true;
    const differsFromStandard = (value, standard) => {
      const match = String(value || '').trim().match(/^(\d+(?:\.\d+)?)\s*(?:mm)?$/i);
      return Boolean(match) && Number(match[1]) > 0 && Number(match[1]) !== standard;
    };
    return differsFromStandard(properties['Rail width'], 75)
      || differsFromStandard(properties['Midrail width'], 153);
  }

  function updateCartLeadTime(cart) {
    const items = (cart.items || []).filter(item => Number(item.variant_id) !== legacySampleFeeVariantId);
    const nextSampleOnly = items.length > 0 && items.every(item => Number(item.product_id) === sampleProductId);
    const nextCustomRailOrder = items.some(hasCustomRailWidth);
    const nextGlazedOrder = items.some(item => ['glazed','glass','mirrored','frosted'].includes(String((item.properties || {}).glazing || '').trim().toLowerCase()));
    if (nextSampleOnly === sampleOnly && nextCustomRailOrder === customRailOrder && nextGlazedOrder === glazedOrder) return;
    sampleOnly = nextSampleOnly;
    customRailOrder = nextCustomRailOrder;
    glazedOrder = nextGlazedOrder;
    refreshMethod();
    if (dateInput.value && !available(chosenMethod(), dateInput.value)) {
      setDate('');
      queueSave();
    }
    updateDateSummary();
    if (calendar.open) renderCalendar();
  }

  async function refreshCartLeadTime() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Could not check delivery lead time');
    updateCartLeadTime(await response.json());
  }

  function deliveryWorkingDays() { return glazedOrder || customRailOrder ? 10 : sampleOnly ? 4 : 8; }
  function deliveryDaysText() { return glazedOrder || customRailOrder ? 'ten' : sampleOnly ? 'four' : '8-9'; }

  function londonToday() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    const part = type => parts.find(item => item.type === type).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
  }

  function utcDate(value) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day));
  }

  function isoDate(value) { return value.toISOString().slice(0, 10); }
  function chosenMethod() { return options.find(option => option.checked)?.value || ''; }
  function isWorkingDay(value) {
    const day = utcDate(value).getUTCDay();
    return day >= 1 && day <= 5 && !bankHolidays.has(value);
  }

  function earliest(method) {
    const date = utcDate(londonToday());
    let remaining = method === 'Collection' ? (glazedOrder ? 10 : 5) : deliveryWorkingDays();
    while (remaining) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (isWorkingDay(isoDate(date))) remaining--;
    }
    while (!allowedWeekday(method, date) || bankHolidays.has(isoDate(date))) {
      date.setUTCDate(date.getUTCDate() + 1);
    }
    return isoDate(date);
  }

  function latest() {
    const date = utcDate(londonToday());
    date.setUTCFullYear(date.getUTCFullYear() + 1);
    return isoDate(date) < lastPublishedDate ? isoDate(date) : lastPublishedDate;
  }

  function allowedWeekday(method, date) {
    const day = date.getUTCDay();
    return method === 'Collection' ? day >= 1 && day <= 5 : day >= 2 && day <= 5;
  }

  function available(method, value) {
    if (!['Collection', 'Delivery'].includes(method) || !/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const date = utcDate(value);
    return isoDate(date) === value && value >= earliest(method) && value <= latest()
      && allowedWeekday(method, date) && !bankHolidays.has(value);
  }

  function formatted(value) {
    return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(utcDate(value));
  }

  function message(value) { error.textContent = value; error.hidden = !value; }

  async function persist(method, value) {
    const currentResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!currentResponse.ok) throw new Error('Could not read cart note');
    const current = await currentResponse.json();
    const preserved = String(current.note || '').split(/\r?\n/).filter(line => !line.startsWith(notePrefix));
    const request = method && value ? `${notePrefix}${method} on ${formatted(value)}` : '';
    const note = [...preserved, request].filter(Boolean).join('\n');
    const response = await fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note, attributes: { [attributeMethod]: method, [attributeDate]: value } })
    });
    if (!response.ok) throw new Error('Could not update cart');
  }

  async function showDateInCheckout() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not read cart items');
    let cart = await response.json();
    const method = chosenMethod();
    const label = method === 'Collection' ? 'Collection date' : 'Delivery date';
    const value = available(method, dateInput.value) ? new Intl.DateTimeFormat('en-GB', {
      day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'
    }).format(utcDate(dateInput.value)) : '';
    const dateKeys = ['Requested fulfilment', 'Delivery date', 'Collection date'];
    const maximumChanges = (cart.items || []).length * 2 + 1;
    for (let attempt = 0; attempt < maximumChanges; attempt++) {
      let target;
      let properties;
      for (const item of cart.items || []) {
        const original = item.properties || {};
        const isSample = Number(item.product_id) === sampleProductId;
        const isDoor = item.product_type !== 'Extras' && item.product_type !== 'Accessories'
          && original['Item type'] !== 'Door sample' && Boolean(original.dimensions);
        if (!isDoor && !isSample && !dateKeys.some(key => Object.prototype.hasOwnProperty.call(original, key))) continue;
        const cleaned = { ...original };
        dateKeys.forEach(key => delete cleaned[key]);
        const desired = (isDoor || isSample) && value ? { [label]: value, ...cleaned } : cleaned;
        if (!Object.keys(desired).length) desired[label] = '';
        if (Object.keys(original).length === Object.keys(desired).length
          && Object.keys(desired).every(key => original[key] === desired[key])) continue;
        target = item;
        properties = desired;
        break;
      }
      if (!target) return;
      const changed = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: target.key, quantity: target.quantity, properties })
      });
      if (!changed.ok) throw new Error('Could not show requested date in checkout');
      cart = await changed.json();
    }
    throw new Error('Could not finish updating requested dates');
  }

  function updateDateSummary() {
    const summary = document.querySelector('[data-jmf-checkout-date]');
    if (!summary) return;
    const method = chosenMethod();
    const value = dateInput.value;
    summary.hidden = !available(method, value);
    if (summary.hidden) return;
    summary.querySelector('[data-jmf-checkout-date-label]').textContent = method === 'Collection' ? 'Requested collection date' : 'Requested delivery date';
    summary.querySelector('[data-jmf-checkout-date-value]').textContent = new Intl.DateTimeFormat('en-GB', {
      weekday: 'short', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'
    }).format(utcDate(value));
  }

  function setDate(value) {
    dateInput.value = value;
    dateText.textContent = value ? formatted(value) : 'Choose date';
    updateDateSummary();
    message('');
  }

  function refreshMethod() {
    const method = chosenMethod();
    dateTrigger.disabled = !method;
    hint.textContent = method === 'Collection'
      ? `From ${glazedOrder ? 'ten' : 'five'} working days${glazedOrder ? ' for glazed, mirrored or frosted doors' : ''} · Mon-Fri, excluding bank holidays`
      : method === 'Delivery'
        ? `From ${deliveryDaysText()} working days${customRailOrder ? ' for custom rail or midrail widths' : sampleOnly ? ' for samples' : ''} · Tue-Fri, excluding bank holidays`
        : 'Choose collection or delivery to see available dates.';
    message('');
  }

  function renderCalendar() {
    const method = chosenMethod();
    const first = utcDate(earliest(method));
    const final = utcDate(latest());
    const monthStart = new Date(Date.UTC(shownMonth.getUTCFullYear(), shownMonth.getUTCMonth(), 1));
    const monthEnd = new Date(Date.UTC(shownMonth.getUTCFullYear(), shownMonth.getUTCMonth() + 1, 0));
    monthTitle.textContent = new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(monthStart);
    previous.disabled = monthStart <= new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth(), 1));
    next.disabled = monthEnd >= final;
    help.textContent = method === 'Collection'
      ? `Collection: Monday to Friday, after ${glazedOrder ? 'ten' : 'five'} full working days. Bank holidays are unavailable.`
      : `Delivery: Tuesday to Friday, from ${deliveryDaysText()} working days${customRailOrder ? ' for custom rail or midrail widths' : sampleOnly ? ' for samples' : ''}. Bank holidays are unavailable.`;
    days.replaceChildren();
    const blank = (monthStart.getUTCDay() + 6) % 7;
    for (let i = 0; i < blank; i++) days.appendChild(document.createElement('span'));
    for (let number = 1; number <= monthEnd.getUTCDate(); number++) {
      const date = new Date(Date.UTC(shownMonth.getUTCFullYear(), shownMonth.getUTCMonth(), number));
      const value = isoDate(date);
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = String(number);
      button.disabled = !available(method, value);
      button.setAttribute('aria-label', new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(date) + (bankHolidays.has(value) ? ', bank holiday unavailable' : button.disabled ? ', unavailable' : ', available'));
      if (dateInput.value === value) button.setAttribute('aria-current', 'date');
      button.addEventListener('click', () => {
        touched = true;
        setDate(value);
        calendar.close();
        dateTrigger.focus();
        queueSave();
      });
      days.appendChild(button);
    }
  }

  async function save() {
    await refreshCartLeadTime();
    const method = chosenMethod();
    const value = dateInput.value;
    if (!method) { message('Choose collection or delivery.'); return false; }
    if (!available(method, value)) {
      message(method === 'Collection'
        ? `Choose an available collection date from ${glazedOrder ? 'ten' : 'five'} working days.`
        : `Choose an available delivery date from ${deliveryDaysText()} working days.`);
      return false;
    }
    await persist(method, value);
    await showDateInCheckout();
    message('');
    return true;
  }

  function queueSave() {
    pending = pending.catch(() => {}).then(async () => {
      if (chosenMethod() && dateInput.value) {
        try { await save(); } catch (_) { message('We could not save your date. Please try again.'); }
      } else {
        try {
          await persist('', '');
          await showDateInCheckout();
        } catch (_) { message('We could not update your choice. Please try again.'); }
      }
    });
  }

  options.forEach(option => option.addEventListener('change', () => {
    touched = true;
    setDate('');
    refreshMethod();
    queueSave();
    dateTrigger.focus();
  }));
  dateTrigger.addEventListener('click', async () => {
    try { await refreshCartLeadTime(); }
    catch (_) { message('We could not check delivery dates. Please try again.'); return; }
    const start = utcDate(dateInput.value || earliest(chosenMethod()));
    shownMonth = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), 1));
    renderCalendar();
    calendar.showModal();
    days.querySelector('button:not(:disabled)')?.focus();
  });
  previous.addEventListener('click', () => { shownMonth.setUTCMonth(shownMonth.getUTCMonth() - 1); renderCalendar(); });
  next.addEventListener('click', () => { shownMonth.setUTCMonth(shownMonth.getUTCMonth() + 1); renderCalendar(); });
  root.querySelector('[data-jmf-calendar-close]').addEventListener('click', () => { calendar.close(); dateTrigger.focus(); });
  calendar.addEventListener('click', event => { if (event.target === calendar) calendar.close(); });

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(response => response.json())
    .then(cart => {
      updateCartLeadTime(cart);
      if (touched) return;
      const method = cart.attributes?.[attributeMethod];
      const option = options.find(item => item.value === method);
      if (option) option.checked = true;
      refreshMethod();
      const value = cart.attributes?.[attributeDate];
      if (option && available(method, value)) { setDate(value); queueSave(); }
    })
    .catch(() => refreshMethod());

  const cartItems = document.querySelector('.cart-main');
  if (cartItems) {
    let cartRefreshTimer;
    new MutationObserver(() => {
      clearTimeout(cartRefreshTimer);
      cartRefreshTimer = setTimeout(() => refreshCartLeadTime().catch(() => {}), 100);
    }).observe(cartItems, { childList: true, subtree: true });
  }

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart"]') || !form.querySelector('[name="checkout"]')) return;
    if (resumeCheckout) { resumeCheckout = false; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await pending;
      if (!await save()) { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (window.JMFSampleDelivery) await window.JMFSampleDelivery.reconcile({ reload: false });
      await showDateInCheckout();
      resumeCheckout = true;
      form.requestSubmit(form.querySelector('[name="checkout"]'));
    } catch (_) {
      resumeCheckout = false;
      message('We could not save your date. Please try again.');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);
})();
